import { render, staticRenderFns } from "./CoverInvoiceDetails.vue?vue&type=template&id=68114673"
import script from "./CoverInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./CoverInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./CoverInvoiceDetails.vue?vue&type=style&index=0&id=68114673&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports